export default __webpack_public_path__ + "static/media/card-1.1147868c.webp";